import "../sprinkles.css.ts.vanilla.css-mistica.js";
import "./aspect-ratio-support.css.ts.vanilla.css-mistica.js";
var a = "yqswj62", n = "_1y2v1nfi7 _1y2v1nfio _1y2v1nfkr _1y2v1nfl6", y = {
    aspectRatio: "var(--yqswj60)"
}, f = "_1y2v1nfkl _1y2v1nfjz _1y2v1nfk0 _1y2v1nfhe";
export { a as container, n as containerWithWrapper, y as vars, f as wrapper };
